import { ReactNode, useEffect } from 'react';
import styled, { FlattenInterpolation, ThemeProps } from 'styled-components';
import { CheckboxInput } from '../../inputs';
import { FormInput, useModelForm } from '../ModelForm';
import { ThemeType } from '../../../../styling';

const CompleteCheckboxWrapper = styled.div<{ successColor?: boolean }>`${({ theme, successColor }) => `
  padding: ${theme.padding[2]} ${theme.padding[3]};
  border-radius: ${theme.padding[2]};
  background: ${successColor ? theme.colours.success[2] : theme.colours.neutral[9]};
`}`;

interface ModelCheckboxProps {
  field: string;
  valueOverride?: boolean;
  errorOverride?: string;
  onVisibleChange?: (b: boolean) => void;
  onBlur?: () => void,
  disabled?: boolean;
  styles?: string;
  mutateValue?: (newValue: boolean) => any,
  label?: ReactNode,
  touchOverride?: boolean;
  containerCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
  checkboxWrapperCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
  hideErrorMessage?: boolean,
  successColor?: boolean,
  isCompleteCheckbox?: boolean,
}

export function ModelCheckbox({
  field,
  valueOverride,
  errorOverride,
  onVisibleChange,
  onBlur,
  disabled,
  styles,
  mutateValue = (newValue) => newValue,
  label,
  touchOverride,
  containerCss,
  checkboxWrapperCss,
  hideErrorMessage = false,
  successColor,
  isCompleteCheckbox = false,
}: ModelCheckboxProps) {
  const {
    visible, errors, warnings, value, update,
  } = useModelForm(field, valueOverride, errorOverride);

  useEffect(() => {
    onVisibleChange?.(visible);
  }, [visible]);

  const checkbox = (
    <CheckboxInput
      id={field}
      value={value}
      onChange={(newValue: boolean) => update({ [field]: mutateValue(newValue) })}
      onBlur={onBlur}
      errors={errors}
      warnings={warnings}
      disabled={disabled}
      styles={styles}
      label={label}
      visible={visible}
      touchOverride={touchOverride}
      checkboxWrapperCss={checkboxWrapperCss}
      hideErrorMessage={hideErrorMessage}
      successColor={successColor}
    />
  );

  return (
    <FormInput visible={visible} css={containerCss}>
      {isCompleteCheckbox ? (
        <CompleteCheckboxWrapper successColor={successColor}>
          {checkbox}
        </CompleteCheckboxWrapper>
      ) : checkbox}
    </FormInput>
  );
}
